import './Hero.scss';
import heroBg from '../../images/hero-bg.jpg';

export default function Hero() {
    return (
        <section
            className="hero"
            style={{ backgroundImage: `url(${heroBg})` }} // ✅ JSX image usage
        >
            <div className="overlay">

                <h1>Let’s find a home that’s perfect for you</h1>
                <p>Search confidently with your trusted source of homes for sale or rent</p>

                {/* SEARCH BOX */}
                <div className="search-box">

                    <select>
                        <option>Property Type</option>
                        <option>House</option>
                        <option>Apartment</option>
                    </select>

                    <select>
                        <option>Location</option>
                        <option>Bangalore</option>
                        <option>Chennai</option>
                        <option>Hyderabad</option>
                        <option>Pune</option>


                    </select>

                    {/* <select>
                        <option>Bedrooms</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>

                    </select>

                    <select>
                        <option>Bathrooms</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>

                    </select> */}

                    <button className="search-btn">🔍 SEARCH</button>

                </div>

            </div>
        </section>
    );
}